import { SecurityService } from './security.service';
import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class RoleGuardService implements CanActivate {
  private roles: any;
  constructor(public auth: AuthService
    , public router: Router
    , private securityService: SecurityService) {
      const showRoles = this.securityService.getUserRolesStorage();
      if (showRoles !== '') {
        this.roles = showRoles.listRoles;
      }
  }
  canActivate(route: ActivatedRouteSnapshot): boolean {

    const expectedModule = route.data.expectedModule;

    if (!this.auth.isAuthenticated() || !this.isAuthorized(expectedModule)) {
      this.router.navigate(['login']);
      return false;
    }
    return true;
  }
  private isAuthorized(expectedRoleModule: string): boolean {
    if (this.roles !== undefined) {
      const acceso = this.roles.filter((item) => item.nameModule === expectedRoleModule)[0];
      return acceso === undefined ? false : true;
    }
  }
}
